/** Base route path for Intraday Optimisation (Trade Hub). */
export const INTRA_DAY_OPTIMISER_BASE_PATH =
  "/trading/trade-hub/intra-day-optimiser";

/**
 * localStorage feature switch for the Trade Hub BM tab + route.
 * Gated in external envs (e.g. prod); on by default in local/dev.
 * Enable in prod: localStorage.setItem("GC166-bm-tab-AD898", "true")
 */
export const BM_AUTOMATION_FEATURE_SWITCH = "GC166-bm-tab-AD898";

/** Intraday section tab path segment keys. */
export const INTRA_DAY_SECTION_TAB = {
  OPTIMISER: "optimiser",
  BM: "bm",
  PREDICTIONS: "predictions",
} as const;

export type IntraDaySectionTab =
  (typeof INTRA_DAY_SECTION_TAB)[keyof typeof INTRA_DAY_SECTION_TAB];

/** Full path for each Intraday section tab. */
export const INTRA_DAY_SECTION_TAB_PATH: Record<IntraDaySectionTab, string> = {
  [INTRA_DAY_SECTION_TAB.OPTIMISER]: `${INTRA_DAY_OPTIMISER_BASE_PATH}/optimiser`,
  [INTRA_DAY_SECTION_TAB.BM]: `${INTRA_DAY_OPTIMISER_BASE_PATH}/bm`,
  [INTRA_DAY_SECTION_TAB.PREDICTIONS]: `${INTRA_DAY_OPTIMISER_BASE_PATH}/predictions`,
};

/** Display label for each Intraday section tab. */
export const INTRA_DAY_SECTION_TAB_LABEL: Record<IntraDaySectionTab, string> = {
  [INTRA_DAY_SECTION_TAB.OPTIMISER]: "Optimiser",
  [INTRA_DAY_SECTION_TAB.BM]: "BM",
  [INTRA_DAY_SECTION_TAB.PREDICTIONS]: "Predictions",
};

/** Default redirect target when visiting the intra-day-optimiser base path. */
export const INTRA_DAY_OPTIMISER_DEFAULT_PATH =
  INTRA_DAY_SECTION_TAB_PATH[INTRA_DAY_SECTION_TAB.OPTIMISER];

/** Vertical order of prediction chart widgets in the Predictions grid. */
export const PREDICTIONS_WIDGET_ORDER = {
  IMBALANCE_FIRST: "imbalance-first",
  M7_FIRST: "m7-first",
} as const;

export type PredictionsWidgetOrder =
  (typeof PREDICTIONS_WIDGET_ORDER)[keyof typeof PREDICTIONS_WIDGET_ORDER];

/** Resolve section tab from pathname. */
export const getIntraDaySectionFromPathname = (
  pathname: string
): IntraDaySectionTab | null => {
  if (
    pathname.startsWith(
      INTRA_DAY_SECTION_TAB_PATH[INTRA_DAY_SECTION_TAB.PREDICTIONS]
    )
  ) {
    return INTRA_DAY_SECTION_TAB.PREDICTIONS;
  }
  if (
    pathname.startsWith(INTRA_DAY_SECTION_TAB_PATH[INTRA_DAY_SECTION_TAB.BM])
  ) {
    return INTRA_DAY_SECTION_TAB.BM;
  }
  if (
    pathname.startsWith(
      INTRA_DAY_SECTION_TAB_PATH[INTRA_DAY_SECTION_TAB.OPTIMISER]
    ) ||
    pathname === INTRA_DAY_OPTIMISER_BASE_PATH
  ) {
    return INTRA_DAY_SECTION_TAB.OPTIMISER;
  }
  return null;
};
